import { authFetch } from "../../HttpClient";
import { uploadFileToBlob } from "../../utils/uploadFileToBlob";

// Appels du rendez-vous assisté (backend controllers/rdvIaController.js et
// routes habituelles des notes de RDV et de Gmail).

const API = "https://backend-myalfa.vercel.app/api";

// Rendez-vous réel (micro, synthèse IA, enregistrement) réservé aux quatre
// testeurs pendant sa mise au point ; les autres gardent la démo. Même liste
// que Home.js et le backend (middleware/accesTesteurs.js), qui vérifie aussi.
const TESTEURS = [
  "nomena@alfa-partenaires.com",
  "jonathan@alfa-partenaires.com",
  "samuel.hoarau@alfacomptabilite.com",
  "anthony.hoarau@alfacomptabilite.com",
];
export const estTesteur = (u) => TESTEURS.includes(String(u?.email || "").toLowerCase());

// Confidentialité : valeurs déjà utilisées par l'ancien écran et la fiche.
export const CONFIDENTIALITES = { public: "Public", associe: "Associé", prive: "Privé" };

async function appel(chemin, options = {}) {
  const res = await authFetch(`${API}${chemin}`, options);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const e = new Error(data.message || data.error || "La demande n'a pas abouti. Réessayez.");
    e.status = res.status;
    throw e;
  }
  return data;
}
const json = (corps) => ({ method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(corps) });

export const chercherProspects = (q) => appel(`/ia-rdv/prospects?q=${encodeURIComponent(q)}`);

export const synthetiser = (corps) => appel("/ia-rdv/synthese", json(corps));

// Insights : le serveur envoie une ligne JSON par événement ({ t: "insight", b },
// puis { t: "fin" } ou { t: "erreur", message }), lue au fil de l'eau pour
// afficher chaque bulle dès qu'elle est prête.
export async function analyserInsights(corps, onEvenement, signal) {
  const res = await authFetch(`${API}/ia-rdv/insights`, { ...json(corps), signal });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    const e = new Error(data.message || "Analyse indisponible pour le moment.");
    e.status = res.status;
    throw e;
  }
  const lecteur = res.body.getReader();
  const decodeur = new TextDecoder();
  let tampon = "";
  const lignes = (fin) => {
    let i;
    while ((i = tampon.indexOf("\n")) >= 0) {
      const l = tampon.slice(0, i).trim();
      tampon = tampon.slice(i + 1);
      if (l) onEvenement(JSON.parse(l));
    }
    if (fin && tampon.trim()) onEvenement(JSON.parse(tampon));
  };
  for (;;) {
    const { value, done } = await lecteur.read();
    if (done) break;
    tampon += decodeur.decode(value, { stream: true });
    lignes(false);
  }
  lignes(true);
}

const taille = (o) => (o < 1024 ? `${o} o` : o < 1048576 ? `${Math.round(o / 1024)} Ko` : `${(o / 1048576).toFixed(1)} Mo`);

// Enregistre la note dans la fiche (route habituelle /note-rdv, multipart).
// Le document joint part d'abord directement vers le stockage, comme dans
// l'ancien écran (pas de limite de 4,5 Mo).
export async function enregistrerNote({ cible, auteur, titre, conf, transcription, notesHtml, synthese, actions, insights, duree, fichier, onProgression }) {
  const fd = new FormData();
  fd.append("clientId", cible.type === "client" ? String(cible.id) : "");
  fd.append("formLeadId", cible.type === "prospect" ? String(cible.id) : "");
  fd.append("utilisateur", auteur);
  fd.append("nom", cible.nom);
  fd.append("titre", titre);
  fd.append("confidentialite", CONFIDENTIALITES[conf] || "Public");
  fd.append("noteDeBase", transcription);
  fd.append("noteManuelle", notesHtml);
  fd.append(
    "noteResume",
    synthese + (actions.length ? "\n\nPoints d'action :\n" + actions.map((a) => `- [${a.qui}] ${a.texte}${a.echeance ? ` (${a.echeance})` : ""}`).join("\n") : ""),
  );
  fd.append("origine", "assistant");
  fd.append("dureeSecondes", String(duree));
  fd.append("actions", JSON.stringify(actions));
  fd.append("insights", JSON.stringify(insights));
  if (fichier) {
    const url = await uploadFileToBlob(fichier, `${API}/note-rdv/upload-token`, ({ percentage }) => onProgression && onProgression(Math.round(percentage)));
    fd.append("documentUrl", url);
    fd.append("documentName", fichier.name);
    fd.append("documentSize", taille(fichier.size));
  }
  return appel("/note-rdv", { method: "POST", body: fd });
}

// Envoi depuis la boîte Gmail connectée du collaborateur (écran Mails).
export const envoyerMail = ({ to, subject, body }) => appel("/users/me/google-mail/send", json({ to, subject, body }));
